import React, { useState } from "react";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { Secao, Segmentado } from "./Base";

const EIXO = { fontSize: 11, fill: "hsl(var(--muted-foreground))" };

function Balao({ active, payload, metricas, titulo }) {
  if (!active || !payload?.[0]) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg border bg-popover px-3 py-2 text-xs shadow-lg space-y-0.5 min-w-[150px]">
      <p className="font-semibold text-sm mb-1">{titulo ? titulo(d) : d.rotulo}</p>
      {metricas.map((m) => (
        <p key={m.key} className="flex justify-between gap-4">
          <span className="text-muted-foreground">{m.rotulo}</span>
          <span className="font-semibold tabular-nums">{m.formatar(d[m.key])}</span>
        </p>
      ))}
    </div>
  );
}

/**
 * Barras de UMA métrica por vez (um eixo só), com o seletor em cima para
 * trocar: faturamento, tempo, ocupação... O balão mostra todas as métricas da
 * barra. A barra mais alta fica cheia e com o valor em cima — o pico salta aos olhos.
 */
export default function GraficoMetrica({ titulo, icone, explicacao, dados, metricas, balaoTitulo, e2e, altura = 260 }) {
  const [chave, setChave] = useState(metricas[0].key);
  const m = metricas.find((x) => x.key === chave) || metricas[0];
  if (!dados?.length) return null;
  const maximo = Math.max(...dados.map((d) => Number(d[m.key]) || 0));
  return (
    <Secao titulo={titulo} icone={icone} explicacao={explicacao} e2e={e2e}
      direita={metricas.length > 1 && <Segmentado opcoes={metricas} valor={m.key} aoMudar={setChave} e2e={`${e2e}-metrica`} />}>
      {m.explicacao && <p className="text-xs text-muted-foreground -mt-2 mb-2">{m.explicacao}</p>}
      <ResponsiveContainer width="100%" height={altura}>
        <BarChart data={dados} margin={{ top: 22, right: 4, left: 0, bottom: 0 }} barCategoryGap="18%">
          <CartesianGrid vertical={false} stroke="hsl(var(--border))" strokeDasharray="3 3" />
          <XAxis dataKey="rotulo" tickLine={false} axisLine={false} tick={EIXO} interval="preserveStartEnd" minTickGap={4} />
          <YAxis tickLine={false} axisLine={false} tick={EIXO} width={56} tickFormatter={m.eixo || m.formatar} allowDecimals={!!m.decimais} />
          <Tooltip cursor={{ fill: "hsl(var(--muted))", opacity: 0.5 }} content={<Balao metricas={metricas} titulo={balaoTitulo} />} />
          <Bar dataKey={m.key} radius={[4, 4, 0, 0]} maxBarSize={40} isAnimationActive={false}>
            {dados.map((d) => (
              <Cell key={d.rotulo} fill="hsl(var(--primary))" fillOpacity={Number(d[m.key]) === maximo && maximo > 0 ? 1 : 0.45} />
            ))}
            <LabelList dataKey={m.key} position="top"
              formatter={(v) => (Number(v) === maximo && maximo > 0 ? m.formatar(v) : "")}
              style={{ fontSize: 11, fontWeight: 700, fill: "hsl(var(--foreground))" }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Secao>
  );
}
